import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import {
  removeSuperBatchesModalStageSelector,
  BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES,
} from 'features/classCreation';
import BulkRemoveSuperBatchesModalConfirmStage from '../BulkRemoveSuperBatchesModalConfirmStage';
import BulkRemoveSuperBatchesModalInfoStage from '../BulkRemoveSuperBatchesModalInfoStage';
import BulkRemoveSuperBatchesModalSelectStage from '../BulkRemoveSuperBatchesModalSelectStage';

export default function BulkRemoveSuperBatchesModalStageRenderer() {
  const modalStage = useSelector(removeSuperBatchesModalStageSelector);
  const [selectedSuperBatches, setSelectedSuperBatches] = useState([]);

  switch (modalStage) {
    case BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES.info:
      return <BulkRemoveSuperBatchesModalInfoStage />;
    case BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES.select:
      return (
        <BulkRemoveSuperBatchesModalSelectStage
          selectedSuperBatches={selectedSuperBatches}
          setSelectedSuperBatches={setSelectedSuperBatches}
        />
      );
    case BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES.confirm:
      return (
        <BulkRemoveSuperBatchesModalConfirmStage
          selectedSuperBatches={selectedSuperBatches}
          setSelectedSuperBatches={setSelectedSuperBatches}
        />
      );
    default:
      return null;
  }
}
